module.exports = __webpack_public_path__ + "img/7de7362.png";